import api from '@/services/api/api'

class LocationsService {
  getAllLocations () {
    return api.get('location').then(result => {
      return result.data
    })
  }

  saveLocation (location) {
    return api.post('location', location)
  }

  removeLocation (location) {
    return api.delete('location/' + location.id)
  }
}

export default new LocationsService()



// WEBPACK FOOTER //
// ./src/services/codebooks/LocationsService.js